export const priorityColorObj: { [key: string]: string } = {
  low: "#848A9C",
  medium: "#FF8817",
  high: "#F63E50",
};

export const ticketStatusConversion: {
  [key: string]: string;
} = {
  "Open Tickets": "open",
  "In Progress": "progress",
  Closed: "done",
};
